import { render, staticRenderFns } from "./Header-user.vue?vue&type=template&id=108a96ba&"
import script from "./Header-user.vue?vue&type=script&lang=js&"
export * from "./Header-user.vue?vue&type=script&lang=js&"
import style0 from "./Header-user.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports